import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AppLauncher } from '@capacitor/app-launcher';

import { TidyUiComponentsModule } from 'src/tidy-ui-components/tidy-ui-components.module';

/**
 * Full-screen, non-dismissable screen shown by AppUpdateService when the native app is
 * older than the minimum supported version.
 */
@Component({
  selector: 'app-update-required',
  templateUrl: './update-required.component.html',
  styleUrls: ['./update-required.component.scss'],
  standalone: true,
  imports: [TidyUiComponentsModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UpdateRequiredComponent {

  // Plain @Input, not a signal input: the app doesn't enable Ionic's useSetInputAPI, so
  // ModalController assigns componentProps with Object.assign.
  @Input() storeUrl: string;

  // AppLauncher, not Util.openUrl: Browser.open would show the store's web page inside the
  // app instead of opening the App Store or Google Play app.
  openStore = async () => {
    try {
      await AppLauncher.openUrl({ url: this.storeUrl });
    } catch (error) {
      console.error('AppUpdate: Error opening the store:', error);
    }
  };
}
